import { render, staticRenderFns } from "./InsularIntro.vue?vue&type=template&id=218fc2fa&"
import script from "./InsularIntro.vue?vue&type=script&lang=js&"
export * from "./InsularIntro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports